import { render, staticRenderFns } from "./UserListTitles.vue?vue&type=template&id=766f4072&"
import script from "./UserListTitles.vue?vue&type=script&lang=js&"
export * from "./UserListTitles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports